<template>
  <main>
    <!-- <topbar guest="true"></topbar> -->
    <navbar active="1" @changeTab="changeTab"></navbar>

    <div class="container pt_108">
      <div v-if="pType === 'games'">
        <div class="bui-head">
          {{ $t("service.choseGame") }}
        </div>
        <div class="bui-con">
          <div
            class="bui-box"
            v-for="game in gameList"
            :key="game.game_base_id"
            @click="selectGame(game)"
          >
            <img :src="game.game_logo" class="box-bg" />
          </div>
        </div>
        <div class="empty-data" v-if="gameList.length == 0 && !btnBusy">
          {{ $t("service.emptyData") }}
        </div>
        <!-- 查看更多 -->
        <div v-if="have_more" class="show_more" @click="getMoreGames">
          {{ $t("service.lookMore") }}
          <span class="icon">
            <img src="../images/arrow_down_circle.svg" alt="" />
          </span>
        </div>

        <div class="data-loading" v-if="btnBusy">
          <div class="loading-wrap">
            <img src="../images/loading.svg" class="loading_icon" />
          </div>
        </div>
      </div>

      <div v-if="pType === 'questions'">
        <div class="bui-head">
          {{ $t("service.userChoseGame") }}：{{ seletedGame.game_name }}
          <span class="re-select" @click="reSelectGame">{{
            $t("service.anewChoseGame")
          }}</span>
        </div>
        <div class="filter_list">
          <div
            class="filter_btn"
            :class="{ on: filter == 0 }"
            @click="filterType(0)"
            gaData="2201001"
          >
            {{ $t("service.all") }}
          </div>
          <div
            class="filter_btn"
            :class="{ on: filter == 50 }"
            @click="filterType(50)"
            ga-data="2202001"
          >
            {{ $t("service.game") }}
          </div>
          <div
            class="filter_btn"
            :class="{ on: filter == 20 }"
            @click="filterType(20)"
            ga-data="2203001"
          >
            {{ $t("service.myCard") }}
          </div>
          <div
            class="filter_btn"
            :class="{ on: filter == 30 }"
            @click="filterType(30)"
            ga-data="2204001"
          >
            {{ $t("service.login") }}
          </div>
          <div
            class="filter_btn"
            :class="{ on: filter == 10 }"
            @click="filterType(10)"
            ga-data="2205001"
          >
            {{ $t("service.account") }}
          </div>
          <div
            class="filter_btn"
            :class="{ on: filter == 70 }"
            @click="filterType(70)"
            ga-data="2206001"
          >
            {{ $t("service.other") }}
          </div>
        </div>

        <search
          class="search-item"
          @searchValChanged="changeList"
          :searchOptions="pageOptions"
          :searchType="filter"
          :selGame="seletedGame"
          :dataFunc="propFunc"
          :datas="qaList"
          ref="searchInput"
        ></search>

        <qaItem
          ref="qItem"
          v-for="(i, index) in qaList"
          :key="index + new Date().getTime()"
          :itemData="i"
        ></qaItem>

        <div v-if="!no_more" class="show_more">
          <div v-if="!btnBusy" @click="getMoreQue">
            {{ $t("service.lookMore") }}
            <span class="icon">
              <img src="../images/arrow_down_circle.svg" alt="" />
            </span>
          </div>
          <img
            src="../images/loading.svg"
            class="loading_icon"
            v-if="btnBusy"
          />
        </div>
      </div>
    </div>

    <selectgameModal
      :formData="formData"
      v-if="isSelectGamePop"
      @closeModal="closeModal"
      @nextStep="nextStep"
    ></selectgameModal>

    <goTop></goTop>

    <!-- <bottombar></bottombar> -->
    <h5-nav pageName="serviceH5" v-if="$region !== 'jp' "></h5-nav>
    <!-- <h5-nav></h5-nav> -->
  </main>
</template>

<script>
import LazyLoad from "vanilla-lazyload/dist/lazyload.js";

// import topbar from '@/component/topbar_h5/index.vue';
// import bottombar from '@/component/bottombar_h5/index.vue';
import h5Nav from "@/component/h5nav/komoe";
import navbar from "./component/navbar";
import goTop from "./component/goTop";
import search from "./component/searchInput";
import qaItem from "./component/qaItem";
import selectgameModal from "./component/selectgameModal";
import { mapGetters } from "vuex";

export default {
  name: "index",
  data() {
    return {
      gameList: [],
      pageInfo: "",
      gameListData: [],
      filter: 0,
      qaList: [],
      pType: "games",
      seletedGame: null,
      pageOptions: {
        index: 1,
        size: 10,
        query: "",
      },
      no_more: false,
      have_more: false,
      gameOptions: {
        index: 1,
        size: 10,
      },
      propFunc: this.$apis.service.commonQuestionList,
      docScrollTop: 0,
      btnBusy: false,
      isSelectGamePop: false,
      formData: {
        game_base_id: "",
        type: 1,
        url: "",
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },

  components: {
    // topbar,
    // bottombar,
    navbar,
    qaItem,
    goTop,
    search,
    selectgameModal,
    h5Nav,
  },
  methods: {
    getMoreGames() {
      this.gameList = this.gameList.concat(
        this.gameListData.slice(
          this.gameOptions.index * this.gameOptions.size,
          (this.gameOptions.index + 1) * this.gameOptions.size
        )
      );
      if (
        (this.gameOptions.index + 2) * this.gameOptions.size >
        this.gameListData.length
      ) {
        this.have_more = false;
      }
      this.gameOptions.index++;
    },
    changeList(arr, val, tag) {
      this.docScrollTop = 0;

      var _this = this;
      _this.qaList = [];
      if (arr && arr.length === this.pageOptions.size) {
        this.no_more = false;
      } else {
        this.no_more = true;
      }
      if (tag === "selectedSingle") {
        this.no_more = true;
      }
      if (val) {
        this.pageOptions.query = val;
      }
      if (arr === "getData") {
        _this.fetchData(_this.seletedGame);
      } else {
        this.qaList = arr;
        this.$nextTick(() => {
          new LazyLoad({
            elements_selector: ".lazy",
            callback_load: () => {
              _this.$emit("loadedImg");
              _this.$refs["qItem"].forEach((ele) => {
                ele.updateBox();
              });
            },
          });
        });
      }
    },
    reSelectGame() {
      this.pType = "games";
      this.filter = 0;
      this.docScrollTop = 0;
      this.$refs["searchInput"].resetInput();
      this.no_more = false;
      this.pageOptions.index = 1;
      this.pageOptions.query = "";
    },
    selectGame(game) {
      this.docScrollTop = 0;
      this.fetchData(game, "select");
    },
    getMoreQue() {
      this.docScrollTop = document.documentElement.scrollTop;

      this.pageOptions.index++;
      this.fetchData(this.seletedGame, "more");
    },
    fetchData(game, tag) {
      if (this.btnBusy) {
        return;
      }

      var _this = this;
      var type = this.filter;
      if (type === 0) {
        type = "";
      }

      this.btnBusy = true;
      this.$apis.service
        .commonQuestionList(
          game.game_base_id,
          type,
          this.pageOptions.index,
          this.pageOptions.size,
          this.pageOptions.query
        )
        .then((res) => {
          if (!tag) {
            _this.qaList = [];
          }

          this.btnBusy = false;

          if (res.data.data && res.data.data.result) {
            if (res.data.data.result.length > 0) {
              var cache = res.data.data.result;

              // 将内容中的图片加上类名class，同时替换src为data-src
              cache.forEach((ca) => {
                ca.question_content
                  .replace("<img", '<img class="lazy"')
                  .replace(" src=", " data-src=");
              });

              if (tag && tag === "more") {
                _this.qaList = _this.qaList.concat(cache);
              } else {
                _this.qaList = cache;
              }

              if (cache.length < _this.pageOptions.size) {
                _this.no_more = true;
              }

              if (tag && tag === "select") {
                window.scrollTo(0, 0);
              }

              _this.pType = "questions";
              _this.seletedGame = game;

              _this.$nextTick(() => {
                new LazyLoad({
                  elements_selector: ".lazy",
                  callback_load: () => {
                    _this.$emit("loadedImg");
                    _this.$refs["qItem"].forEach((ele) => {
                      ele.updateBox();
                    });
                  },
                });

                if (tag && tag === "more") {
                  _this.intervalCheck(_this.docScrollTop);
                }
              });
            } else {
              _this.no_more = true;
            }
          }
        });
    },
    intervalCheck(pos) {
      window.scrollTo(0, pos);

      setTimeout(() => {
        if (document.documentElement.scrollTop !== pos) {
          this.intervalCheck(pos);
        }
      }, 100);
    },
    filterType(i) {
      this.filter = i;
      this.no_more = false;
      this.pageOptions.index = 1;
      this.pageOptions.query = "";
      this.docScrollTop = 0;

      this.$refs["searchInput"].resetInput();

      this.fetchData(this.seletedGame);
    },
    goTo(url) {
      this.formData.url = url;
      // 判断是否登录
      if (this.userInfo && this.userInfo.mid) {
        this.nextStep();
      } else {
        this.isSelectGamePop = true;
      }
    },
    // 关闭选择游戏弹窗
    closeModal() {
      this.isSelectGamePop = false;
      this.formData.url = "";
      this.formData.game_base_id = "";
    },
    // 跳转路由
    nextStep() {
      // 判断有没有登录
      if (this.userInfo && this.userInfo.mid) {
        this.$router.push({
          path: this.formData.url,
          query: this.formData.game_base_id,
        });
      } else {
        this.goLogin(this.formData.type);
      }
    },
    // 切换导航栏
    changeTab(url) {
      this.formData.url = url;
      // 判断是否登录
      if (this.userInfo && this.userInfo.mid) {
        this.nextStep();
      } else {
        this.isSelectGamePop = true;
      }
    },
    // 去登录
    goLogin(gameType) {
      let url;
      const redirect = this.formData.game_base_id
        ? encodeURIComponent(
            `${location.origin}${this.formData.url}?game_base_id=${this.formData.game_base_id}`
          )
        : encodeURIComponent(`${location.origin}${this.formData.url}`);
      if (gameType === 2) {
        // 新游戏
        url = `https://${this.$siteConfig.passportDomain}/login/?type=both&redirect=${redirect}`;
      } else {
        // 老游戏
        url = `https://${this.$siteConfig.passportDomain}/login/?redirect=${redirect}`;
      }
      window.location.href = url;
    },
  },
  created() {
    // 获取游戏列表
    this.pageInfo = this.$route.name;
    this.$apis.service.commonGameList().then((res) => {
      if (res.data.code == 0) {
        if (res.data.data) {
          this.gameListData = res.data.data;

          if (res.data.data.length > this.gameOptions.size) {
            this.have_more = true;
            this.gameList = this.gameListData.slice(0, this.gameOptions.size);
          } else {
            this.gameList = this.gameListData;
          }
        }
      }
    });
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "../../scss/common_h5.scss";
</style>
<style lang="scss" scoped>
/deep/ .container {
  .data-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-top: 1.08rem;
    opacity: 0;
    box-sizing: border-box;
    animation: loading 0.4s forwards;
    .loading-wrap {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.6);
      .loading_icon {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 0.6rem;
        height: 0.6rem;
        transform: translate(-50%, -50%);
      }
    }
  }

  .empty-data {
    position: relative;
    top: 0.2rem;
    text-align: center;
    font-size: 0.12rem;
    color: #bdbdbd;
  }

  .search-box {
    margin-bottom: 0.2rem;
    height: 0.4rem;
    font-size: 0.12rem;
    .search-icon {
      top: 0.14rem;
      right: 0.12rem;
      width: 0.12rem;
      height: 0.12rem;
      fill: #50bbe5;
    }
  }

  .bui-head {
    position: relative;
    margin: 0 auto;
    padding: 0.2rem 0;
    width: 3.36rem;
    line-height: 20px;
    font-size: 0.12rem;
    color: #444;
    .re-select {
      float: right;
      margin-left: 10px;
      color: #50bbe5;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .bui-box {
    position: relative;
    margin: 0 auto;
    margin-bottom: 0.1rem;
    width: 3.36rem;
    height: 1.9rem;
    border: 1px solid #eeeeee;
    border-radius: 12px;
    box-sizing: border-box;
    cursor: pointer;
    .box-bg {
      display: block;
      width: 100%;
      height: 100%;
    }
    .box-cover {
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
  .show_more {
    text-align: center;
    font-size: 0.16rem;
    line-height: 0.32rem;
    color: #444444;
    img {
      width: 0.12rem;
    }
    .loading_icon {
      display: inline-block;
      width: 0.3rem;
      height: 0.3rem;
    }
  }

  .filter_list {
    font-size: 0;
    display: flex;
    flex-wrap: wrap;
    .filter_btn {
      flex-grow: 0;
      flex-shrink: 0;
      width: 29.7%;
      height: 0.3rem;
      font-size: 0.12rem;
      text-align: center;
      line-height: 0.3rem;
      background-color: #eeeeee;
      color: #999999;
      border-radius: 0.15rem;
      margin: 0 0 0.12rem;
      margin-right: 5%;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:nth-child(3n) {
        margin-right: 0;
      }
      &.on {
        background-color: $cl_green;
        color: #ffffff;
      }
    }
  }

  .selected {
    margin: 0.14rem 0;
  }

  .line_btn {
    background: #00b900;
    border-radius: 0.1rem;
    height: 0.5rem;
    margin: 0.4rem 0 0.2rem;
    .line_left {
      background: url(../images/logo_line.svg) center center no-repeat;
      background-size: 0.31rem auto;
      height: 0.5rem;
      width: 0.5rem;
      float: left;
      border-right: 1px solid #01ae00;
    }
    .line_right {
      float: right;
      width: 2.85rem;
      text-align: center;
      line-height: 0.5rem;
      font-size: 0.2rem;
      color: #ffffff;
    }
  }
}

@keyframes loading {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
